// src/services/emailService.js
// Cliente frontend de los correos transaccionales. Llama a las funciones
// serverless de Vercel en /api, que son las que realmente envían vía Resend
// (la API key de Resend NUNCA vive en el browser).
//
// Todas las llamadas son "fire-and-forget": si algo falla (por ejemplo en
// `npm start`, donde no existe /api) se loguea y se sigue — nunca rompen
// el flujo principal de la app.
import supabase from '../supabase';

// POST autenticado a un endpoint /api/*. Adjunta el JWT de la sesión actual.
async function authedPost(path, body) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) {
      return { ok: false, error: 'no_session' };
    }

    const res = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body || {}),
    });

    // En desarrollo (npm start) /api no existe y devuelve el index.html:
    // detectamos respuestas no-JSON para no romper.
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      return { ok: false, error: 'endpoint_unavailable' };
    }

    const data = await res.json();
    return data;
  } catch (err) {
    console.warn(`[emailService] ${path} no disponible:`, err.message);
    return { ok: false, error: err.message };
  }
}

export const emailService = {
  // Notifica por email al destinatario de un mensaje recién enviado.
  async notifyNewMessage(messageId) {
    if (!messageId) return { ok: false, error: 'missing_messageId' };
    return authedPost('/api/notify-message', { messageId });
  },

  // Envía el correo de bienvenida al usuario autenticado (post verificación).
  async sendWelcomeEmail() {
    return authedPost('/api/welcome', {});
  },

  // Notifica un evento de membresía técnico ↔ empresa. event: 'request_received'
  // | 'invite_received' | 'request_approved' | 'request_rejected' | 'member_removed'.
  async notifyMembershipEvent(membershipId, event) {
    if (!membershipId || !event) return { ok: false, error: 'missing_params' };
    return authedPost('/api/notify-membership', { membershipId, event });
  },
};

export default emailService;
